import { makeAutoObservable, runInAction } from 'mobx'

import { serverMessage } from '@/Ship/Helpers/serverError'

import { assignedRoles, toggleRole } from '../Contracts/UserOptions'
import { PatchUserTask } from '../Tasks/PatchUserTask'

/**
 * Вкладка «Права доступу»: ролі зберігаються одразу на кожне перемикання
 * (`PATCH {roles}`, як у легасі). Відмову бека видно: перемикач повертається,
 * а пояснення сервера стоїть над перемикачами — у легасі помилка губилася
 * мовчки (`SPEC-005` §7.2).
 */
export class UserRolesManager {
    roles: string[] = []
    /** Роль, що зберігається зараз: решта перемикачів чекає */
    pending: string | null = null
    error: string | null = null

    constructor(initial: unknown) {
        this.roles = assignedRoles(initial)
        makeAutoObservable(this)
    }

    /** Збережені ролі (з відповіді бека) або `null`, якщо бек відмовив. */
    async toggle(uuid: string, role: string, enabled: boolean): Promise<string[] | null> {
        if (this.pending !== null) return null

        const previous = this.roles
        const next = toggleRole(previous, role, enabled)

        this.pending = role
        this.error = null
        this.roles = assignedRoles(next)

        try {
            const response = await PatchUserTask(uuid, { roles: next })
            const saved = Array.isArray(response.roles) ? response.roles : next

            runInAction(() => {
                this.roles = assignedRoles(saved)
            })

            return saved.filter((code): code is string => typeof code === 'string')
        } catch (error) {
            runInAction(() => {
                this.roles = previous
                this.error = serverMessage(error, 'Не вдалося змінити ролі співробітника.')
            })

            return null
        } finally {
            runInAction(() => {
                this.pending = null
            })
        }
    }
}
